import * as React from "react";
import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { isPermitted } from "util/PermissionsMixin";
import Routes from "routing/Routes";
import SecurityRoutes from "security-app/routing/Routes";
import { LinkContainer } from "components/common";
import { BootstrapModalConfirm, MenuItem, DeleteMenuItem } from "components/bootstrap";
import { useDeleteAsset } from "security-app/hooks/useAssetsAPI";
import { useSelectedRowsDispatch } from "common/contexts";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useCurrentUser from "hooks/useCurrentUser";
import useAssetIdSearchParam from "security-app/hooks/useAssetIdSearchParam";
import { MoreActionsMenu } from "components/common/MoreActions";
const RowActions = ({ asset, openAssetModal, showDelete = true, showEdit = true }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const selectedAssetsDispatch = useSelectedRowsDispatch();
  const { saveAssetIdSearchParam } = useAssetIdSearchParam();
  const navigate = useNavigate();
  const { deleteAsset } = useDeleteAsset();
  const sendTelemetry = useSendTelemetry();
  const { permissions } = useCurrentUser();
  const canManageAssets = useMemo(() => isPermitted(permissions, "asset:edit"), [permissions]);
  const onEdit = () => {
    openAssetModal(asset);
  };
  const onDelete = () => {
    setShowDeleteModal(true);
  };
  const onConfirmedDelete = async () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SECURITY_APP.ASSET_DELETED, {
      app_pathname: "security",
      app_section: "asset"
    });
    await deleteAsset({ assetId: asset.id });
    selectedAssetsDispatch({ type: "remove", payload: [asset] });
  };
  const showAssetDashboard = (assetId) => () => {
    saveAssetIdSearchParam(assetId);
    navigate(`${SecurityRoutes.ACTIVITY.ASSET_DRILLDOWN}?assetId=${assetId}`);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MoreActionsMenu, { title: "Toggle asset actions" }, /* @__PURE__ */ React.createElement(MenuItem, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: Routes.search(`associated_assets:${asset.id}`, { relative: 0 }) }, /* @__PURE__ */ React.createElement("div", null, "Search for asset"))), /* @__PURE__ */ React.createElement(MenuItem, { onClick: showAssetDashboard(asset.id) }, "Asset Dashboard"), canManageAssets ? /* @__PURE__ */ React.createElement("div", null, showEdit && /* @__PURE__ */ React.createElement(MenuItem, { onClick: onEdit }, "Edit"), showDelete && /* @__PURE__ */ React.createElement(React.Fragment, null, showEdit && /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onClick: onDelete }))) : /* @__PURE__ */ React.createElement("div", null)), showDelete && /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      title: "Are you sure you want to delete this asset?",
      onConfirm: onConfirmedDelete,
      onCancel: () => setShowDeleteModal(false),
      showModal: showDeleteModal
    },
    /* @__PURE__ */ React.createElement("div", null, "You are about to delete this asset: ", asset.name)
  ));
};
export default RowActions;
